import { format, isValid, parse } from "date-fns";

// Date-only values stay local: UTC conversion can shift the calendar day.
export const parseIncomingDate = (value) => {
  if (!value || typeof value !== "string") return null;
  const date = parse(value, "yyyy-MM-dd", new Date());
  return isValid(date) ? date : null;
};

export const formatIncomingDate = (value) => {
  const date = parseIncomingDate(value);
  return date ? format(date, "dd/MM/yyyy") : "";
};

export const parseIncomingCreatedAt = (value) => {
  if (value == null || value === "") return null;
  const date = value instanceof Date ? value
    : typeof value.toDate === "function" ? value.toDate()
    : typeof value.seconds === "number" ? new Date(value.seconds * 1000 + (value.nanoseconds || 0) / 1000000)
    : typeof value === "string" || typeof value === "number" ? new Date(value) : null;
  return isValid(date) ? date : null;
};

export const formatIncomingCreatedAt = (value) => {
  const date = parseIncomingCreatedAt(value);
  return date ? date.toLocaleString("en-GB", {
    day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit", hour12: false, timeZone: "Asia/Bangkok",
  }) : "";
};

export const isValidIncomingBirthDate = (value) => Boolean(
  typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value) &&
  parseIncomingDate(value) && value >= "1900-01-01" && value <= format(new Date(), "yyyy-MM-dd")
);

export const buddhistBirthDateToIso = (value) => {
  const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value.trim());
  if (!match) return null;
  const year = Number(match[3]) - 543;
  if (year < 1) return null;
  const iso = `${String(year).padStart(4, "0")}-${match[2]}-${match[1]}`;
  // Validate after conversion so leap days follow the Gregorian year.
  return isValidIncomingBirthDate(iso) ? iso : null;
};

export const formatBuddhistBirthDate = (value) => {
  const date = parseIncomingDate(value);
  return date ? `${format(date, "dd/MM")}/${date.getFullYear() + 543}` : "";
};
